import React from "react";
import { useNavigate } from "react-router-dom";
import ApiRequest from "../services/apiService";
import baseUrl from "../services/baseUrl";
import "../assets/stylesheet/login.scss";
const Logout = () => {
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      const url = `${baseUrl()}/Account/Logout`;

      const response = await ApiRequest({
        apiLink: url,
        method: "GET",
      });
      if (response.message === "Logged out successfully") {
        sessionStorage.clear();
        localStorage.clear();
        window.location.reload();
      } else {
        console.error("Logout failed");
      }
    } catch (error) {
      console.error("Error:", error);
    }
    navigate('/login');
    sessionStorage.clear();
    localStorage.clear();
    window.location.reload();
  }

  return (
    <button className="logoutBtn" onClick={handleLogout}>
      Logout
    </button>
  );
};

export default Logout;
